import moment from "moment";

import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IAutoResponderViewProps {
    note: string;
    from: Date;
    to: Date;
}

class AutoResponderView extends React.Component<IAutoResponderViewProps> {
    // todo: build autoresponders form

    public render(): JSX.Element {
        return (
            <div className="row">
                <div className="col-sm-12 col-md-8 col-lg-3">
                    <div>
                        <strong>{cacheStore.GetString("FromLabel")}: </strong>
                        {this.props.from &&
                            <span>{moment(this.props.from).format("YYYY/MM/DD")} </span>
                        }
                        {!this.props.from &&
                            <span> -- </span>
                        }
                        <strong>{cacheStore.GetString("ToLabel")}: </strong>
                        {this.props.to &&
                            <span>{moment(this.props.to).format("YYYY/MM/DD")} </span>
                        }
                        {!this.props.to &&
                            <span> -- </span>
                        }
                    </div>
                    <div style={{ padding: "10px 0" }}>
                        <textarea className="form-control" rows={4} value={this.props.note} readOnly={true} />
                    </div>
                    <div>
                        <a onClick={this.ShowEditControls.bind(this)} style={{ marginRight: "8px" }}>{cacheStore.GetString("ModifyLabel")}</a>
                        <a onClick={this.ClearOnVacation.bind(this)}>{cacheStore.GetString("ClearLabel")}</a>
                    </div>
                </div>
            </div>
        );
    }

    private ShowEditControls(e: React.MouseEvent<HTMLAnchorElement>): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalOperations.SettingsUI.AutoRespondersControlShow);
        LocalEventDispatcher.dispatch(operation);
    }

    private ClearOnVacation(e: React.MouseEvent<HTMLAnchorElement>): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalOperations.Settings.ClearAutoResponder);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { AutoResponderView };
